import { useContext, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { MessageContext } from "../context/MessageContext";

function ForgotPassword() {
  const navigate = useNavigate();

  const [newPassword, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const { showMessage } = useContext(MessageContext);

  const token = localStorage.getItem("token");
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const API_URL = process.env.REACT_APP_API_URL;
    const res = await fetch(
      `${API_URL}/forgot-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({ email, newPassword, confirmPassword }),
    });

    const data = await res.json();
    console.log(data.message);

    if (data.success === true) {
      showMessage(data.message, "success");
      navigate("/login");
    } else {
      showMessage(data.message, "danger");
      navigate("/forgot-password");
    }
  }
  return (
    <>
      <div style={{ marginBottom: '50px' }}></div>
      <div className="page-title">
        <nav className="breadcrumbs">
          <div className="container">
            <ol>
              <li><NavLink to="/">Home</NavLink></li>
              <li className="current">Forgot-password</li>
            </ol>
          </div>
        </nav>
      </div>
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-lg-5 col-md-7">
              <div className="card shadow-sm">
                <div className="card-body p-4">

                  <h4 className="text-center mb-4">
                    <i className="bi bi-person-circle me-2"></i>
                    Forgot Password
                  </h4>

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">New Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter password" value={newPassword} onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Confirm Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter confirm password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                    </div>

                    <div className="d-grid">
                      <button type="submit" className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </form>

                  <div className="text-center mt-4">
                    <span className="small">
                      If you have an account?
                    </span>{" "}
                    <NavLink to="/login" className="fw-semibold">
                      Login
                    </NavLink>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default ForgotPassword;
